
import React from "react";

interface BlogHeaderProps {
  title: string;
  description: string;
}

const BlogHeader: React.FC<BlogHeaderProps> = ({ title, description }) => {
  return (
    <section className="bg-sage-50 py-8 md:py-12">
      <div className="container-custom">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">{title}</h1>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl">
          {description}
        </p>
      </div>
    </section>
  );
};

export default BlogHeader;
